import { ApiConfig, HttpService, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { MS_PER_MINUTE } from '@skylab-shared/utils';
import { ReportPrintQuery, ReportPrintQueryParameters, ReportPrintResult } from '../queries/report-print.query-base';

export interface PurchaseRegistryPrintingResult extends ReportPrintResult { }

export interface PurchaseRegistryPrintingParameters extends ReportPrintQueryParameters { }

export class PurchaseRegistryPrintingQuery extends ReportPrintQuery<PurchaseRegistryPrintingResult> {
    public constructor(parameters: PurchaseRegistryPrintingParameters) {
        super(parameters);
    }
}

export class PurchaseRegistryPrintingQueryHandlerBase implements QueryHandler<PurchaseRegistryPrintingQuery, PurchaseRegistryPrintingResult> {
    private static Url = TaggedUrl.join('purchaseRegistry/printing', [Tags.Api]);

    public constructor(private readonly http: HttpService) {  }

    public async handleAsync({ parameters }: PurchaseRegistryPrintingQuery): Promise<PurchaseRegistryPrintingResult> {
        const requestData = {
            compress: parameters.compress,
            password: parameters.password,
            ecoMode: parameters.ecoMode,
            landscape: parameters.landscape,
            config: {
                parameters: JSON.stringify(parameters.parameters),
                columns: parameters.columns,
                summary: parameters.summary,
                report: 'RejestrZakupow'
            }
        };

        const { data } = await this.http.post<{ url: string; }>(PurchaseRegistryPrintingQueryHandlerBase.Url, requestData, {timeout: 3 * MS_PER_MINUTE });
        return {
            url: `${ApiConfig.baseUrl}${data.url}`
        };
    }
}
